import { useEffect, useState } from 'react';
import { X } from 'lucide-react';

let dismissedThisSession = false;
function shouldShow() {
  if (dismissedThisSession) return false;
  try {
    const style = localStorage.getItem('moyu-page-style');
    return (
      style !== 'classic' &&
      style !== 'island' &&
      localStorage.getItem('moyu-theme-welcome-v1') !== 'done'
    );
  } catch {
    return true;
  }
}
export function ThemeWelcome({ menuOpen, onOpen }: { menuOpen: boolean; onOpen: () => void }) {
  const [visible, setVisible] = useState(shouldShow);
  function dismiss() {
    dismissedThisSession = true;
    try {
      localStorage.setItem('moyu-theme-welcome-v1', 'done');
    } catch {}
    setVisible(false);
  }
  useEffect(() => {
    if (menuOpen) dismiss();
  }, [menuOpen]);
  if (!visible || menuOpen) return null;
  return (
    <aside className="theme-discovery-hint" aria-label="主题切换提示">
      <button className="theme-hint-close" aria-label="关闭主题提示" onClick={dismiss}>
        <X size={15} />
      </button>
      <strong>在这里，换个小岛风格</strong>
      <p>界面和明暗模式，都能随心切换。</p>
      <button
        className="theme-hint-action"
        onClick={() => {
          dismiss();
          onOpen();
        }}
      >
        试试换主题 →
      </button>
    </aside>
  );
}
